export default "__VITE_ASSET__hR2vxQlu__"